import styled, { css } from 'styled-components'
import { sizeMobile } from 'components/globalStyles'

export const MainContainer = styled.div`
  ${props => props.sizeToFit && css`
    width: 0;
    min-width: 100%;
  `}

  & ol {
    counter-reset: number;
    padding: 20px 0;

    & li {
      list-style: none;
      padding-bottom: 8px;

      &::before {
        counter-increment: number;
        content: '0'counter(number);
        font-size: 2rem;
        font-weight: 600;
        font-variant-numeric: tabular-nums;
        padding-right: 16px;
      }

      @media (max-width: ${sizeMobile}) {
        font-size: 1.6rem;

        &::before {
          font-size: 1.8rem;
        }
      }
    }
  }

  & ul {
    list-style: disc;
    list-style-position: inside;
    padding: 20px 0;

    & li {
      padding-bottom: 8px;
    }
  }

  & strong {
    font-weight: 600;
  }
`
